import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export interface AppPageTitleProps {
  /** Omit when the app toolbar breadcrumbs are the page heading. */
  title?: string;
  /** @deprecated Breadcrumbs belong in the app toolbar. */
  subheader?: React.ReactNode;
  description?: string;
  /** Primary actions (right side on sm+). Prefer `useAppToolbar({ pageActions })` for toolbar placement. */
  actions?: React.ReactNode;
}

const AppPageTitle: React.FC<AppPageTitleProps> = ({ title, subheader, description, actions }) => {
  if (!title && !subheader && !description) {
    return null;
  }

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      justifyContent="space-between"
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      spacing={1}
      sx={{ flexShrink: 0 }}
    >
      <Box>
        {subheader}
        {title ? (
          <Typography variant="h4" component="h1">
            {title}
          </Typography>
        ) : null}
        {description ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: title ? 0.5 : 0 }}>
            {description}
          </Typography>
        ) : null}
      </Box>
      {actions ? (
        <Stack direction="row" spacing={1} alignItems="center" useFlexGap flexWrap="wrap">
          {actions}
        </Stack>
      ) : null}
    </Stack>
  );
};

export default AppPageTitle;
